// Inventory screens (product list, item details, delete-confirm) previously
// used inconsistent placeholders for a missing model/brand value — '—', '--',
// and 'N/A' across different files. Standardized on 'N/A' since it was
// already the convention in both InventoryDetailsDesktop and
// InventoryDetailsMobile.
export const formatInventoryFieldValue = (value?: string | null): string =>
  value || 'N/A';
